<script>
    import { userInfo } from "../Me.svelte";

    // config
    export let first = true;
    export let last = false;
    export let placeholder = "dear stranger";
    export let strong = false;

    export let model;

    let request;

    $: hasFirstOrlast = model && model.firstName && model.lastName;
    $: fade = model && !hasFirstOrlast;

    if (!model) {
        request = userInfo().then(response => {
            model = response.data.me.user;
        })
    }
</script>

<span class="user-name" class:strong class:fade>
    {#if model}
        {#if hasFirstOrlast}
            <!-- TODO: deduplicate -->
            <span class="user-name-first" class:hidden={!first}>{model.firstName}</span>
            <span class="user-name-last" class:hidden={!last}>{model.lastName}</span>
        {:else}
            (no name set yet)
        {/if}
    {:else}
        {#await userInfo()}
            ...
        {:then response}
            <!-- TODO: deduplicate -->
            <span class="user-name-first" class:hidden={!first}>{model.firstName}</span>
            <span class="user-name-last" class:hidden={!last}>{model.lastName}</span>
        {:catch err}
            {placeholder}
        {/await}
    {/if}
</span>

<style>
    .user-name-first, .user-name-last {
        text-transform: capitalize;
    }

    span.hidden {
        display: none;
    }

    span.strong {
        font-weight: bold;
    }

    span.fade {
        color: #CCC;
    }
</style>